import { ref, computed, onMounted, onUnmounted } from 'vue'

let resizeTimer: ReturnType<typeof setTimeout>

export const useDimension = (props = { isHeaderDynamic: true }) => {
  const screenWidth = ref(window.innerWidth)
  const size = computed(() => ({
    isSmall: screenWidth.value <= 767,
    isMedium: screenWidth.value >= 768 && screenWidth.value <= 1023,
    isLarge: screenWidth.value >= 1024
  }))

  const headerNavHeight = computed(() => {
    switch (true) {
      case !props.isHeaderDynamic:
        return 0
      case size.value.isSmall:
        return 45
      case size.value.isMedium:
        return 61
      default:
        return 72
    }
  })
  function computeHeaderHeight() {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      screenWidth.value = window.innerWidth
    }, 50)
  }
  onMounted(() => {
    if (props.isHeaderDynamic) {
      window.addEventListener('resize', computeHeaderHeight)
      computeHeaderHeight()
    }
  })

  onUnmounted(() => {
    if (props.isHeaderDynamic) {
      window.removeEventListener('resize', computeHeaderHeight)
    }
  })

  return {
    headerNavHeight,
    screenWidth,
    size
  }
}
